module.exports = __webpack_public_path__ + "static/media/greater_than.e072764b.svg";